import products from '../../../constants/products';
import subscriptionDataJson from '../../MySubscription/mySubscriptionData.json';
import type { Feature, SubscriptionData } from '../../MySubscription/types';

export const IDENTITY_BENEFITS = [
  'Daily score updates',
  'Daily dark web monitoring',
  'Lock your Experian Credit Report',
  'Anti-fraud alerts',
  'Anti-fraud expert support',
];

export const CREDIT_EXPERT_BENEFITS = [
  'Daily score updates',
  'Your score forecast',
  'What impacts your score',
  'Actions to improve your score',
  'Daily dark web monitoring',
  'Lock your Experian Credit Report',
  'Anti-fraud alerts',
  'Credit report monitoring',
  'Anti-fraud expert support',
  'Call us for support',
];

/** Maps CancelSubscription benefit labels → MySubscription feature labels */
export const CANCEL_BENEFIT_TO_FEATURE_LABEL: Record<string, string> = {
  'Daily score updates': 'Your score and report',
  'Daily dark web monitoring': 'Dark web monitoring',
  'Lock your Experian Credit Report': 'Lock your Experian Credit Report',
  'Anti-fraud alerts': 'Anti-fraud alerts',
  'Anti-fraud expert support': 'Anti-fraud expert support',
  'Your score forecast': 'Your score forecast',
  'What impacts your score': 'What impacts your score',
  'Actions to improve your score': 'Actions to improve your score',
  'Call us for support': 'Call us for support',
  'Credit report monitoring': 'Credit report monitoring',
};

const subscriptionData = subscriptionDataJson as SubscriptionData;

const allFeatures = subscriptionData.featureSections.flatMap(section => section.features);

export type CancelSubscriptionProduct =
  | typeof products.identity
  | typeof products.credit_expert
  | typeof products.basic;

export const getSubscriptionDisplayName = (currentSubscription: CancelSubscriptionProduct): string =>
  currentSubscription === products.credit_expert ? 'CreditExpert' : 'Identity Plus';

export const getLostBenefits = (currentSubscription: CancelSubscriptionProduct): string[] =>
  currentSubscription === products.credit_expert ? CREDIT_EXPERT_BENEFITS : IDENTITY_BENEFITS;

export const splitBenefitsIntoColumns = (benefits: string[]): [string[], string[]] => {
  const midpoint = Math.ceil(benefits.length / 2);
  return [benefits.slice(0, midpoint), benefits.slice(midpoint)];
};

/**
 * Resolves a cancel-page benefit to a Feature for EntitlementInfoModal.
 * Keeps the cancel-page label as the modal title; uses mapped feature info/values.
 */
export const getFeatureForCancelBenefit = (benefitLabel: string): Feature | null => {
  const featureLabel = CANCEL_BENEFIT_TO_FEATURE_LABEL[benefitLabel];
  if (!featureLabel) return null;

  const feature = allFeatures.find(f => f.label === featureLabel);
  if (!feature) return null;

  return { ...feature, label: benefitLabel };
};
